import { parse, stringify } from 'query-string';

export const parseQueryParams = (locationSearch) =>
  locationSearch ? parse(locationSearch) : null;

export const buildSearchQueryParams = (params = {}) => {
  if (Object.keys(params).length === 0) return '';
  else return `?${stringify(params)}`;
};
